import * as React from 'react';
import * as tech from "./style.module.scss"
export const Tech = () => {
  return (
    <section className={tech.tech}>
      <div className="container">
        <h2>Технологии Advance</h2>
        <ul>
          <li>
            <img src="https://fs.advance.ru/landing-pages/about/tehno-icon-01.svg" alt=""/>
            <h3>Легко освоить</h3>
            <p>уже на первых занятиях</p>
          </li>
          <li>
            <img src="https://fs.advance.ru/landing-pages/about/tehno-icon-02.svg" alt=""/>
            <h3>Подходят всем</h3>
            <p>и новичкам, и опытным</p>
          </li>
          <li>
            <img src="https://fs.advance.ru/landing-pages/about/tehno-icon-03.svg" alt=""/>
            <h3>Дают результат</h3>
            <p>99% учеников получают его в заявленные сроки</p>
          </li>
          <li>
            <img src="https://fs.advance.ru/landing-pages/about/tehno-icon-04.svg" alt=""/>
            <h3>Проверены наукой</h3>
            <p>подробно описаны и протестированы на тысячах учеников</p>
          </li>
        </ul>
      </div>
    </section>
  );
};
